import { fetchRequest } from "../helpers/util/requestMiddleware";
import Config from "@skin_config";

export const getBMSBanners = async (partnerId) => (
  fetchRequest(Config.bms.apiUrl, 'api/banner/getactivebannersbypartnerid', 'POST', {
    body: { partnerId },
  })
);